export default {
  shape:
    '<path fill="#22CCD8" d="m8.85 17.275 3.15-1.9 3.15 1.925-.825-3.6 2.775-2.4-3.65-.325-1.45-3.4-1.45 3.375-3.65.325L9.675 13.7l-.825 3.575Zm-1.525 2.1 1.25-5.325L4.45 10.5l5.425-.475L12 5l2.125 5.025 5.425.475-4.125 3.55 1.25 5.325L12 16.55l-4.675 2.825Z"/>',
  viewBox: [0, 0, 24, 24],
};
